<template>
  <div class="newsDetail">
    <div class="head">
      <img src="../../assets/images/fanhui.png" alt @click="prevPage" />
      <p class="t-title">{{news.title}}</p>
      <p class="time">发布时间：{{news.updateTime*1000 | formatDate}}</p>
    </div>

    <div v-html="news.context" class="context">{{news.context}}</div>
    <p class="relative-p" style="margin-left:35.5px">相关阅读:</p>
    <div class="relative" v-for="(item,index) in relativeList" :key="index">
      <img class="dot" src="../../assets/images/tr_list-sytle.png" alt />
      <p @click="relative(item.id)">{{item.title}}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsId: "",
      news: "",
      date: "",
      relativeList: "",
      reletiveId: "",
      type: this.$route.params.type,
    };
  },
   watch: {
    newsId: {
      handler: function() {
        var num = this.$route.params.id
        if(~num.indexOf('_')){
          this.newsId = num.split('_')[1]
        }else{
          this.newsId=this.$route.params.id
        }
        this.getRelativeList();
        this.getRelative(this.newsId);
      },
      immediate: true
    }
  },
  updated() {
    let con = document.getElementsByClassName('context')[0];
    let p  = con.children
    if(p.length > 0 ) {
      for (let i = 0; i < p.length; i++) {
            
              p[i].style.color = '#565656';
            }
    }
  },
  mounted(){
    var num = this.$route.params.id
        if(~num.indexOf('_')){
          this.newsId = num.split('_')[1]
        }else{
          this.newsId=this.$route.params.id
        }
        this.getRelativeList();
        this.getRelative(this.newsId);
  },
  methods: {
    relative(id) {
      this.newsId = id;
      this.$router.replace({ path: `/CommonQuestion/${id}.html`});
    },
    getRelative(val) {
      this.newsId = this.$route.params.id;
      this.axios.get(`/api/consume/CommonQuestion/${this.newsId}`).then(res => {
        this.news = res.data;
        document.title = this.news.title;
        const ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == "micromessenger") {
          this.$weChat.share(this.news.title,sessionStorage.getItem('routerUri'), res.data.summary, res.data.imageUrl);
        }
      });
      // window.scrollTo(0, 0);
    },
    getRelativeList() {
      this.axios
        .get("/api/consume/CommonQuestion/RelativeList", {
          params: {
            id: this.newsId,
            num: 3
          }
        })
        .then(res => {
          this.relativeList = res.data;
        });
    },
    prevPage() {
      this.$personBack()
    }
  }
};
</script>

<style>
.newsDetail {
  clear: both;
  /* overflow: hidden; */
}
.newsDetail .head {
  background: #f8f8f8;
  text-align: center;
  padding: 0 35.5px;
  overflow: hidden;
  padding-bottom: 34px;
}
.newsDetail .head img {
  width: 21px !important;
  height: 40px !important;
  margin-top: 42px;
  /* margin-left: 35.5px; */
  float: left;
}
.newsDetail .head .t-title {
  font-size: 30px;
  margin: 0 auto;
  margin-top: 37px !important;
  color: #282828;
  width: 604px;
  padding-bottom: 28px;
  border-bottom: 1px solid #e2e2e2;
  margin-bottom: 20px !important;
}
.newsDetail .context {
  padding: 35.5px;
}
.newsDetail .context >>> p>span {
  color: #565656;
}
.newsDetail img {
  width: 100% !important;
  height: auto !important;
}
.time {
  color: #a1a1a1;
  font-size: 22px;
  clear: both;
}

.relative {
  padding-left: 35.5px;
  font-size: 30px;
  overflow: hidden;
  margin-top: 5px;
}
.relative .dot {
  width: 10px !important;
  height: 10px;
  float: left;
  margin-top: 24px;
  margin-left: 30px;
  /* margin-right: 6px; */
}
.relative p {
  color: #444;
  font-size: 26px;
  line-height: 60px;
  float: left;
  margin: 0;
  margin-left: 20px;
  width: 600px;
}
.relative-p{
  font-size: 32px;
  padding-left: 20px;
  font-weight: bold;
  position: relative;
}
.relative-p::before {
   content: "";
  width: 6px;
  height: 30px;
  background-color: #64b3f1;
  position: absolute;
  left: 0;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/commonQuestion/CommonQuestion.vue